import styled from 'styled-components'

export const Container = styled.nav`
  width: 100%;
  height: 42px;
  min-height: 42px;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.08) 0%,
      rgba(0, 0, 0, 0.16) 100%
    ),
    ${({ theme }) => theme.colors.header || theme.colors.primary || '#2c30af'};
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  z-index: 95;
  overflow: hidden;
`

export const NavList = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const NavItem = styled.button<{ active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 30px;
  padding: 0 12px;
  border-radius: 6px;
  font-size: 12.5px;
  font-weight: ${({ active }) => (active ? '700' : '500')};
  color: ${({ active }) => (active ? '#ffffff' : '#e2e8f0')};
  background-color: ${({ active }) =>
    active ? 'rgba(255, 255, 255, 0.22)' : 'transparent'};
  border: 1px solid
    ${({ active }) => (active ? 'rgba(255, 255, 255, 0.35)' : 'transparent')};
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;

  svg {
    color: ${({ active }) => (active ? '#ffffff' : '#cbd5e1')};
    transition: color 0.15s ease;
  }

  &:hover {
    background-color: ${({ active }) =>
      active ? 'rgba(255, 255, 255, 0.26)' : 'rgba(255, 255, 255, 0.12)'};
    color: #ffffff;

    svg {
      color: #ffffff;
    }
  }

  &:active {
    transform: scale(0.98);
  }
`

export const NavIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`

export const NavLabel = styled.span`
  line-height: 1;
  letter-spacing: -0.01em;
`
